import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  SAVEDBIOGRAPHY: {
    path: `${baseRoutes.userBaseRoutes}saved-biography`,
  },
};

export default accessRoute;
